import styled, { keyframes } from "styled-components";

const waveAnim = keyframes`
  0% {
    transform: rotate(0deg);
  }
    50% {
    transform: rotate(-12deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

const StyledHelloView = styled.div`
  main {
    display: grid;
    justify-items: center;
    align-content: center;
    text-align: center;
    padding: 30px;
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  .profile-photo-container {
    position: relative;
    user-select: none;
    pointer-events: none;

    .profile-photo {
      height: 100px;
      width: 100px;
      border-radius: 100%;
      overflow: hidden;
      position: relative;

      img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
      }

      &::after {
        content: "";
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        border-radius: 100%;
        box-shadow: inset 0 0 0 1px rgb(0, 0, 0, 0.1);
        z-index: 1;
      }
    }

    .hand {
      position: absolute;
      z-index: 2;
      bottom: -6px;
      left: -10px;
      display: flex;
      font-size: 40px;

      span {
        animation: infinite 1.5s ${waveAnim} ease-in-out;
        transform-origin: bottom right;
        display: flex;
      }
    }
  }

  h1 {
    font-weight: 500;
    letter-spacing: -0.04rem;
    font-size: 30px;
    margin-top: 20px;
    color: ${({ theme }) => theme.color.gray[900]};
  }

  p {
    max-width: 250px;
    margin: 10px auto 0 auto;
    line-height: 22px;
    color: ${({ theme }) => theme.color.gray[500]};
  }

  .connect-btn {
    height: 60px;
    margin-top: 30px;
    box-shadow: inset 0 -2px 6px rgb(0, 0, 0, 0.1), 0 2px 6px rgb(0, 0, 0, 0.2);
    border-radius: 50rem;
    background-color: #0a66c2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    padding: 0 24px;
    color: white;
    user-select: none;
    text-decoration: none;

    svg {
      height: 22px;
      margin-right: 12px;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;

export default StyledHelloView;
